var $a9b740b7d23548d0$exports = {};
$a9b740b7d23548d0$exports = {
  "pending": `\u{BCF4}\u{B958} \u{C911}`
};
export { $a9b740b7d23548d0$exports as default };